// extracted by mini-css-extract-plugin
export default {"sign_in":"VerificationSent_sign_in__7+bBn"};